import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import AppComponentBase from '@shared/common/app-component-base';

import AppNavigationService from '../app-navigation.service';

@Component({
    selector: 'menu-search-bar',
    templateUrl: './menu-search-bar.component.html',
    styleUrls: ['./menu-search-bar.component.css'],
    standalone: false,
})
class MenuSearchBarComponent extends AppComponentBase {
    allMenuItems: any[];

    searchMenuResults: any[];

    isMenuSearchActive = false;

    selected: '';

    constructor(injector: Injector, private _appNavigationService: AppNavigationService, private router: Router) {
        super(injector);
        this.initializeMenuSearch();
    }

    showMenuItem(menuItem): boolean {
        return this._appNavigationService.showMenuItem(menuItem);
    }

    searchMenuItem(event) {
        this.searchMenuResults = this.allMenuItems
            .filter((item) =>
                item.name.toLowerCase()
                    .includes(event.query.toLowerCase()) ||
                item.route.toLowerCase()
                    .includes(event.query.toLowerCase()))
            .map((menuItem) => ({
                name: menuItem.name,
                route: menuItem.route,
                external: menuItem.external,
                parameters: menuItem.parameters,
            }));
    }

    selectMenuItem(event) {
        if (event?.route) {
            if (event.external) {
                window.open(event.route, '_blank');
            } else {
                this.router.navigate([event.route], { queryParams: event.parameters })
                    .then(() => {
                        this.selected = '';
                    });
            }
        }
    }

    private getAllMenuItems() {
        return this._appNavigationService
            .getAllMenuItems()
            .filter((item) => this.showMenuItem(item) && item.route)
            .map((menuItem) => ({
                name: this.l(menuItem.name),
                route: menuItem.route,
                external: menuItem.external,
                parameters: menuItem.parameters,
            }));
    }

    private initializeMenuSearch() {
        this.isMenuSearchActive = false;
        const themeSettings = this.currentTheme.baseSettings;

        if (themeSettings?.menu?.searchActive) {
            this.allMenuItems = this.getAllMenuItems();
            this.isMenuSearchActive = true;
        }
    }
}

export default MenuSearchBarComponent;
